'use client';

import React from 'react';
import Image from 'next/image';

const Card = ({ className = '', title, img, ...props }) => {
  const baseClasses =
    'block max-w-[406px] bg-white/[0.03] backdrop-blur-sm border border-white/15 hover:border-accent/60 transition-colors p-8';

  return (
    <div className={`${baseClasses} ${className}`} {...props}>
      <div className='flex flex-col items-start space-y-6'>
        <div className='w-[88px] h-[88px] bg-gradient-to-br from-accent/40 to-accent/0 border border-accent/60 rounded-xl flex items-center justify-center'>
          <Image
            src={img}
            alt='Feature'
            width={40}
            height={40}
            className='brightness-0 invert'
          />
        </div>
        <h3 className='text-2xl font-montserrat font-medium text-white leading-[33px] max-w-[300px]'>
          {title}
        </h3>
      </div>
    </div>
  );
};

export default Card;
